import React, { useEffect, useState } from 'react';
import { Arrow, Checkbox, HeaderContent, MarketingOptions, Section, SectionContent, SectionHeader } from './style';
import { Flex } from '../style';
import { CheckBox } from '../../../styles/commonStyle';
import { FieldValues, UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { ResponseModel, RESULT } from '../../../model/response';
import { Stipulation } from '../../../model/stipulation';
import useFetch from '../../../hooks/useFetch';
import { stipulation1Selector, stipulation2Selector, stipulation3Selector, stipulationSOCSelector } from '../../../recoil/variableAtom';
const parse = require("html-react-parser");

interface TermsAgreementProps {
    onChange?: (value: {
        requiredChecked: boolean;
        optional: {
            marketing: boolean;
            email: boolean;
            sms: boolean;
            soc: boolean;
        };
        all: {
            terms: boolean;
            privacy: boolean;
            location: boolean;
            age: boolean;
            soc: boolean;
            marketing: boolean;
            email: boolean;
            sms: boolean;
        };
    }) => void;
    // useForm 관련 props 추가
    register?: UseFormRegister<FieldValues>;
    setValue?: UseFormSetValue<FieldValues>;
    getValues?: UseFormGetValues<FieldValues>;
    isEdit?: boolean;
    initialValues?: {
        terms: boolean;
        privacy: boolean;
        location: boolean;
        age: boolean;
        soc: boolean;
        marketing: boolean;
        email: boolean;
        sms: boolean;
    };
}

export default function TermsAgreement({
    onChange,
    register,
    setValue,
    getValues,
    isEdit = false,
    initialValues }: TermsAgreementProps) {

    const [term01, setTerm01] = useState<React.ReactNode>(null);
    const [term02, setTerm02] = useState<React.ReactNode>(null);
    const [term03, setTerm03] = useState<React.ReactNode>(null);
    const [term04, setTerm04] = useState<React.ReactNode>(null);
    const response1: ResponseModel<Stipulation> = useFetch({
        recoilSelector: stipulation1Selector,
    });
    const response2: ResponseModel<Stipulation> = useFetch({
        recoilSelector: stipulation2Selector,
    });
    const response3: ResponseModel<Stipulation> = useFetch({
        recoilSelector: stipulation3Selector,
    });
    const response4: ResponseModel<Stipulation> = useFetch({
        recoilSelector: stipulationSOCSelector,
    });
    useEffect(() => {
        if (response1?.result === RESULT.FAIL) {
            alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
        } else {
            var res = response1?.data?.cn;
            setTerm01(res);
        }
    }, [response1]);
    useEffect(() => {
        if (response2?.result === RESULT.FAIL) {
            alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
        } else {
            var res = response2?.data?.cn;
            setTerm02(res);
        }
    }, [response2]);
    useEffect(() => {
        if (response3?.result === RESULT.FAIL) {
            alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
        } else {
            var res = response3?.data?.cn;
            setTerm03(res);
        }
    }, [response3]);
    useEffect(() => {
        if (response4?.result === RESULT.FAIL) {
            alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
        } else {
            var res = response4?.data?.cn;
            setTerm04(res);
        }
    }, [response4]);
    const [openIdx, setOpenIdx] = useState(-1);
    const [checked, setChecked] = useState(initialValues || {
        terms: false,
        privacy: false,
        location: false,
        age: false,
        soc: false,
        marketing: false,
        email: false,
        sms: false,
    });

    const requiredChecked = checked.terms && checked.privacy && checked.location && checked.age;

    // 전체 동의 체크 여부 계산 (기존 코드 유지)
    const allChecked =
        checked.terms &&
        checked.privacy &&
        checked.location &&
        checked.age &&
        checked.soc &&
        checked.marketing &&    
        checked.email &&
        checked.sms;

    useEffect(() => {
        if (onChange) {
            onChange({
                requiredChecked,
                optional: {
                    marketing: checked.marketing,
                    email: checked.email,
                    sms: checked.sms,
                    soc: checked.soc,
                },
                all: checked,
            });
        }
    }, [checked, onChange]);

    // useForm이 있을 경우 setValue 호출
    useEffect(() => {
        if (setValue) {
            Object.entries(checked).forEach(([key, value]) => {
                setValue(key, value);
            });
        }
    }, [checked, setValue]);

    const handleToggle = (idx: number) => setOpenIdx(openIdx === idx ? -1 : idx);

    const handleCheck = (key: keyof typeof checked) => {
        let newChecked = { ...checked };

        if (key === 'marketing') {
            const newValue = !checked.marketing;
            newChecked = {
                ...checked,
                marketing: newValue,
                email: newValue,
                sms: newValue,
            };
        } else if (key === 'email' || key === 'sms') {
            const newValue = !checked[key];
            newChecked = {
                ...checked,
                [key]: newValue,
            };
            if (newChecked.email || newChecked.sms) {
                newChecked.marketing = true;
            } else if (!newChecked.email && !newChecked.sms) {
                newChecked.marketing = false;
            }
        } else {
            newChecked = {
                ...checked,
                [key]: !checked[key],
            };
        }

        setChecked(newChecked);

        // useForm이 있는 경우 setValue 호출
        if (setValue) {
            Object.entries(newChecked).forEach(([k, v]) => {
                setValue(k, v);
            });
        }
    };

    // handleAllCheck도 같은 방식으로 수정
    const handleAllCheck = () => {
        const newValue = !allChecked;
        const newChecked = {
            terms: newValue,
            privacy: newValue,
            location: newValue,
            age: newValue,
            soc: newValue,
            marketing: newValue,
            email: newValue,
            sms: newValue,
        };

        setChecked(newChecked);

        // useForm이 있는 경우 setValue 호출
        if (setValue) {
            Object.entries(newChecked).forEach(([k, v]) => {
                setValue(k, v);
            });
        }
    };

    // 체크박스 렌더링 함수는 단순화
    const renderCheckbox = (key: keyof typeof checked, label: string, id: string) => (
        <CheckBox
            type="checkbox"
            checked={checked[key]}
            onChange={() => handleCheck(key)}
            id={id}
            disabled={isEdit}
        />
    );

    return (
        <div>
            {/* 1. 이용약관 */}
            <Section>
                <SectionHeader onClick={() => handleToggle(0)}>
                    <HeaderContent>
                        {renderCheckbox('terms', 'evPlug 회원 통합 이용약관 (필수)', 'terms')}
                        <label htmlFor="terms">evPlug 회원 통합 이용약관 (필수)</label>
                    </HeaderContent>
                    <Arrow open={openIdx === 0}>⌃</Arrow>
                </SectionHeader>
                {openIdx === 0 && (
                    <SectionContent>
                        {<div>{parse(term01)}</div>}
                    </SectionContent>
                )}
            </Section>

            <Section>
                <SectionHeader onClick={() => handleToggle(1)}>
                    <HeaderContent>
                        {renderCheckbox('privacy', '개인정보 수집 및 이용 동의 (필수)', 'privacy')}
                        <label htmlFor="privacy">개인정보 수집 및 이용 동의 (필수)</label>
                    </HeaderContent>
                    <Arrow open={openIdx === 1}>⌃</Arrow>
                </SectionHeader>
                {openIdx === 1 && (
                    <SectionContent>
                        {<div>{parse(term02)}</div>}
                    </SectionContent>
                )}
            </Section>

            <Section>
                <SectionHeader onClick={() => handleToggle(2)}>
                    <HeaderContent>
                        {renderCheckbox('location', '위치정보 기반 서비스 이용약관 동의 (필수)', 'location')}
                        <label htmlFor="location">위치정보 기반 서비스 이용약관 동의 (필수)</label>
                    </HeaderContent>
                    <Arrow open={openIdx === 2}>⌃</Arrow>
                </SectionHeader>
                {openIdx === 2 && (
                    <SectionContent>
                        {<div>{parse(term03)}</div>}
                    </SectionContent>
                )}
            </Section>

            <Section>
                <SectionHeader>
                    <HeaderContent>
                        {renderCheckbox('age', '만 14세 이상(필수)', 'age')}
                        <label htmlFor="age">만 14세 이상(필수)</label>
                    </HeaderContent>
                </SectionHeader>
            </Section>

            <Section>
                <SectionHeader onClick={() => handleToggle(3)}>
                    <HeaderContent>
                        {renderCheckbox('soc', '스마트충전기 배터리 정보 제3자 제공 (선택)', 'soc')}
                        <label htmlFor="soc">스마트충전기 배터리 정보 제3자 제공 (선택)</label>
                    </HeaderContent>
                    <Arrow open={openIdx === 3}>⌃</Arrow>
                </SectionHeader>
                {openIdx === 3 && (
                    <SectionContent>
                        {<div>{parse(term04)}</div>}
                    </SectionContent>
                )}
            </Section>

            <Section>
                <SectionHeader cursor="default">
                    <HeaderContent>
                        {renderCheckbox('marketing', '마케팅 활용/광고성 정보 수신동의 (선택)', 'marketing')}
                        <label htmlFor="marketing">마케팅 활용/광고성 정보 수신동의 (선택)</label>
                    </HeaderContent>
                </SectionHeader>
                <SectionContent isNoBorder={true} padding="0 0 20px 30px">
                    충전요금 할인 이벤트 등 다양한 프로모션 및 이벤트 소식을 보내드립니다.
                    <MarketingOptions>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {renderCheckbox('email', 'E-mail', 'email')}
                            E-mail
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {renderCheckbox('sms', 'SMS', 'sms')}
                            SMS
                        </label>
                    </MarketingOptions>
                </SectionContent>
            </Section>

            <Flex margin="20px 0 0 0" gap="10px">
                <CheckBox
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleAllCheck}
                    id="all"
                    disabled={isEdit}
                />
                <label htmlFor="all" style={{ fontWeight: 500, fontSize: '1.1rem' }}>
                    회원통합 이용약관 전체 동의
                </label>
            </Flex>
        </div>
    );
}